import styles from './Slider.module.css';
import Link from 'next/link';
import { Text } from '@/_components';
import type { FC } from 'react';
import type { SliderProps } from './Slider.types';

export const Slider: FC<SliderProps> = ({ items }) => {
  if (!items?.length) return null;

  return (
    <nav className={styles.slider}>
      {items.map((item, key) => {
        const slideContent = item.href ? (
          <Link href={item.href}>{item.name}</Link>
        ) : (
          <>{item.name}</>
        );

        return (
          <div key={key} onClick={item.onClick}>
            <Text>{slideContent}</Text>
          </div>
        );
      })}
    </nav>
  );
};
